/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BusinessErrorTypeDto } from '../models';
// @ts-ignore
import type { ResolveMultipleErrorsRequestDtoDto } from '../models';
// @ts-ignore
import type { ValidationErrorStatisticsDtoDto } from '../models';
// @ts-ignore
import type { ValidationErrorsPageDtoDto } from '../models';
// @ts-ignore
import type { ValidationResolutionChoiceDto } from '../models';
// @ts-ignore
import type { ValidationResolveByTypeRequestDto } from '../models';
/**
 * ValidationApi - axios parameter creator
 * @export
 */
export const ValidationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Picks one of the resolutions the error offers in resolutionOptions and marks the error resolved. The choice is applied when the upload continues: SKIP_ROW leaves the rows out of the import, KEEP_SAP_NUMBER imports only the row with the given SAP number and leaves the other rows sharing its e-mail out, ACCEPT_SAP_NUMBER lets the stored employee take over the new SAP number.
         * @summary Choose how to resolve a validation error
         * @param {string} uploadId 
         * @param {string} errorId 
         * @param {ValidationResolutionChoiceDto} validationResolutionChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chooseValidationErrorResolution: async (uploadId: string, errorId: string, validationResolutionChoiceDto: ValidationResolutionChoiceDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('chooseValidationErrorResolution', 'uploadId', uploadId)
            // verify required parameter 'errorId' is not null or undefined
            assertParamExists('chooseValidationErrorResolution', 'errorId', errorId)
            // verify required parameter 'validationResolutionChoiceDto' is not null or undefined
            assertParamExists('chooseValidationErrorResolution', 'validationResolutionChoiceDto', validationResolutionChoiceDto)
            const localVarPath = `/api/v2/uploads/{uploadId}/validation-errors/{errorId}/resolution`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)))
                .replace(`{${"errorId"}}`, encodeURIComponent(String(errorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validationResolutionChoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Continue upload after resolving errors
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueUpload: async (uploadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('continueUpload', 'uploadId', uploadId)
            const localVarPath = `/api/v2/uploads/{uploadId}/continue`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get validation error statistics grouped by type
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationErrorStatistics: async (uploadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('getValidationErrorStatistics', 'uploadId', uploadId)
            const localVarPath = `/api/v2/uploads/{uploadId}/validation-errors/statistics`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get validation errors for an upload
         * @param {string} uploadId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationErrors: async (uploadId: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('getValidationErrors', 'uploadId', uploadId)
            const localVarPath = `/api/v2/uploads/{uploadId}/validation-errors`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get validation errors filtered by business error type
         * @param {string} uploadId 
         * @param {BusinessErrorTypeDto} businessErrorType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationErrorsByBusinessType: async (uploadId: string, businessErrorType: BusinessErrorTypeDto, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('getValidationErrorsByBusinessType', 'uploadId', uploadId)
            // verify required parameter 'businessErrorType' is not null or undefined
            assertParamExists('getValidationErrorsByBusinessType', 'businessErrorType', businessErrorType)
            const localVarPath = `/api/v2/uploads/{uploadId}/validation-errors/business-type/{businessErrorType}`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)))
                .replace(`{${"businessErrorType"}}`, encodeURIComponent(String(businessErrorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Without a body every error of the type is accepted as it is; for SAP_NUMBER_CHANGED that means the stored employee takes over the new SAP number. With a body the given resolution is chosen for every error of the type - allowed are ACCEPT_SAP_NUMBER (SAP_NUMBER_CHANGED) and SKIP_ROW (SAP_NUMBER_CHANGED, EMPLOYEE_EMAIL_CONFLICT). EMPLOYEE_EMAIL_CONFLICT always needs a resolution.
         * @summary Resolve all validation errors of specific business type
         * @param {string} uploadId 
         * @param {BusinessErrorTypeDto} businessErrorType 
         * @param {ValidationResolveByTypeRequestDto} [validationResolveByTypeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveErrorsByBusinessType: async (uploadId: string, businessErrorType: BusinessErrorTypeDto, validationResolveByTypeRequestDto?: ValidationResolveByTypeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('resolveErrorsByBusinessType', 'uploadId', uploadId)
            // verify required parameter 'businessErrorType' is not null or undefined
            assertParamExists('resolveErrorsByBusinessType', 'businessErrorType', businessErrorType)
            const localVarPath = `/api/v2/uploads/{uploadId}/validation-errors/business-type/{businessErrorType}/resolve`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)))
                .replace(`{${"businessErrorType"}}`, encodeURIComponent(String(businessErrorType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validationResolveByTypeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve multiple validation errors
         * @param {string} uploadId 
         * @param {ResolveMultipleErrorsRequestDtoDto} [resolveMultipleErrorsRequestDtoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveMultipleValidationErrors: async (uploadId: string, resolveMultipleErrorsRequestDtoDto?: ResolveMultipleErrorsRequestDtoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('resolveMultipleValidationErrors', 'uploadId', uploadId)
            const localVarPath = `/api/v2/uploads/{uploadId}/validation-errors/resolve-multiple`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveMultipleErrorsRequestDtoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts the error as it is. An error that offers a choice of resolutions is resolved with its acceptance (SAP_NUMBER_CHANGED: the stored employee takes over the new SAP number); one without an acceptance, such as EMPLOYEE_EMAIL_CONFLICT, needs a resolution chosen through the resolution endpoint.
         * @summary Resolve a specific validation error
         * @param {string} uploadId 
         * @param {string} errorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveValidationError: async (uploadId: string, errorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('resolveValidationError', 'uploadId', uploadId)
            // verify required parameter 'errorId' is not null or undefined
            assertParamExists('resolveValidationError', 'errorId', errorId)
            const localVarPath = `/api/v2/uploads/{uploadId}/validation-errors/{errorId}/resolve`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)))
                .replace(`{${"errorId"}}`, encodeURIComponent(String(errorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidationApi - functional programming interface
 * @export
 */
export const ValidationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidationApiAxiosParamCreator(configuration)
    return {
        /**
         * Picks one of the resolutions the error offers in resolutionOptions and marks the error resolved. The choice is applied when the upload continues: SKIP_ROW leaves the rows out of the import, KEEP_SAP_NUMBER imports only the row with the given SAP number and leaves the other rows sharing its e-mail out, ACCEPT_SAP_NUMBER lets the stored employee take over the new SAP number.
         * @summary Choose how to resolve a validation error
         * @param {string} uploadId 
         * @param {string} errorId 
         * @param {ValidationResolutionChoiceDto} validationResolutionChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chooseValidationErrorResolution(uploadId: string, errorId: string, validationResolutionChoiceDto: ValidationResolutionChoiceDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chooseValidationErrorResolution(uploadId, errorId, validationResolutionChoiceDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.chooseValidationErrorResolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Continue upload after resolving errors
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueUpload(uploadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueUpload(uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.continueUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get validation error statistics grouped by type
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidationErrorStatistics(uploadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationErrorStatisticsDtoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidationErrorStatistics(uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.getValidationErrorStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get validation errors for an upload
         * @param {string} uploadId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidationErrors(uploadId: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationErrorsPageDtoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidationErrors(uploadId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.getValidationErrors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get validation errors filtered by business error type
         * @param {string} uploadId 
         * @param {BusinessErrorTypeDto} businessErrorType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidationErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationErrorsPageDtoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidationErrorsByBusinessType(uploadId, businessErrorType, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.getValidationErrorsByBusinessType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Without a body every error of the type is accepted as it is; for SAP_NUMBER_CHANGED that means the stored employee takes over the new SAP number. With a body the given resolution is chosen for every error of the type - allowed are ACCEPT_SAP_NUMBER (SAP_NUMBER_CHANGED) and SKIP_ROW (SAP_NUMBER_CHANGED, EMPLOYEE_EMAIL_CONFLICT). EMPLOYEE_EMAIL_CONFLICT always needs a resolution.
         * @summary Resolve all validation errors of specific business type
         * @param {string} uploadId 
         * @param {BusinessErrorTypeDto} businessErrorType 
         * @param {ValidationResolveByTypeRequestDto} [validationResolveByTypeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, validationResolveByTypeRequestDto?: ValidationResolveByTypeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveErrorsByBusinessType(uploadId, businessErrorType, validationResolveByTypeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.resolveErrorsByBusinessType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resolve multiple validation errors
         * @param {string} uploadId 
         * @param {ResolveMultipleErrorsRequestDtoDto} [resolveMultipleErrorsRequestDtoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveMultipleValidationErrors(uploadId: string, resolveMultipleErrorsRequestDtoDto?: ResolveMultipleErrorsRequestDtoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveMultipleValidationErrors(uploadId, resolveMultipleErrorsRequestDtoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.resolveMultipleValidationErrors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts the error as it is. An error that offers a choice of resolutions is resolved with its acceptance (SAP_NUMBER_CHANGED: the stored employee takes over the new SAP number); one without an acceptance, such as EMPLOYEE_EMAIL_CONFLICT, needs a resolution chosen through the resolution endpoint.
         * @summary Resolve a specific validation error
         * @param {string} uploadId 
         * @param {string} errorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveValidationError(uploadId: string, errorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveValidationError(uploadId, errorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidationApi.resolveValidationError']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValidationApi - factory interface
 * @export
 */
export const ValidationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidationApiFp(configuration)
    return {
        /**
         * Picks one of the resolutions the error offers in resolutionOptions and marks the error resolved. The choice is applied when the upload continues: SKIP_ROW leaves the rows out of the import, KEEP_SAP_NUMBER imports only the row with the given SAP number and leaves the other rows sharing its e-mail out, ACCEPT_SAP_NUMBER lets the stored employee take over the new SAP number.
         * @summary Choose how to resolve a validation error
         * @param {string} uploadId 
         * @param {string} errorId 
         * @param {ValidationResolutionChoiceDto} validationResolutionChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chooseValidationErrorResolution(uploadId: string, errorId: string, validationResolutionChoiceDto: ValidationResolutionChoiceDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.chooseValidationErrorResolution(uploadId, errorId, validationResolutionChoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Continue upload after resolving errors
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueUpload(uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.continueUpload(uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get validation error statistics grouped by type
         * @param {string} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationErrorStatistics(uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<ValidationErrorStatisticsDtoDto> {
            return localVarFp.getValidationErrorStatistics(uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get validation errors for an upload
         * @param {string} uploadId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationErrors(uploadId: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<ValidationErrorsPageDtoDto> {
            return localVarFp.getValidationErrors(uploadId, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get validation errors filtered by business error type
         * @param {string} uploadId 
         * @param {BusinessErrorTypeDto} businessErrorType 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidationErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<ValidationErrorsPageDtoDto> {
            return localVarFp.getValidationErrorsByBusinessType(uploadId, businessErrorType, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Without a body every error of the type is accepted as it is; for SAP_NUMBER_CHANGED that means the stored employee takes over the new SAP number. With a body the given resolution is chosen for every error of the type - allowed are ACCEPT_SAP_NUMBER (SAP_NUMBER_CHANGED) and SKIP_ROW (SAP_NUMBER_CHANGED, EMPLOYEE_EMAIL_CONFLICT). EMPLOYEE_EMAIL_CONFLICT always needs a resolution.
         * @summary Resolve all validation errors of specific business type
         * @param {string} uploadId 
         * @param {BusinessErrorTypeDto} businessErrorType 
         * @param {ValidationResolveByTypeRequestDto} [validationResolveByTypeRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, validationResolveByTypeRequestDto?: ValidationResolveByTypeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resolveErrorsByBusinessType(uploadId, businessErrorType, validationResolveByTypeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve multiple validation errors
         * @param {string} uploadId 
         * @param {ResolveMultipleErrorsRequestDtoDto} [resolveMultipleErrorsRequestDtoDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveMultipleValidationErrors(uploadId: string, resolveMultipleErrorsRequestDtoDto?: ResolveMultipleErrorsRequestDtoDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resolveMultipleValidationErrors(uploadId, resolveMultipleErrorsRequestDtoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts the error as it is. An error that offers a choice of resolutions is resolved with its acceptance (SAP_NUMBER_CHANGED: the stored employee takes over the new SAP number); one without an acceptance, such as EMPLOYEE_EMAIL_CONFLICT, needs a resolution chosen through the resolution endpoint.
         * @summary Resolve a specific validation error
         * @param {string} uploadId 
         * @param {string} errorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveValidationError(uploadId: string, errorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resolveValidationError(uploadId, errorId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidationApi - interface
 * @export
 * @interface ValidationApi
 */
export interface ValidationApiInterface {
    /**
     * Picks one of the resolutions the error offers in resolutionOptions and marks the error resolved. The choice is applied when the upload continues: SKIP_ROW leaves the rows out of the import, KEEP_SAP_NUMBER imports only the row with the given SAP number and leaves the other rows sharing its e-mail out, ACCEPT_SAP_NUMBER lets the stored employee take over the new SAP number.
     * @summary Choose how to resolve a validation error
     * @param {string} uploadId 
     * @param {string} errorId 
     * @param {ValidationResolutionChoiceDto} validationResolutionChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    chooseValidationErrorResolution(uploadId: string, errorId: string, validationResolutionChoiceDto: ValidationResolutionChoiceDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Continue upload after resolving errors
     * @param {string} uploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    continueUpload(uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get validation error statistics grouped by type
     * @param {string} uploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    getValidationErrorStatistics(uploadId: string, options?: RawAxiosRequestConfig): AxiosPromise<ValidationErrorStatisticsDtoDto>;

    /**
     * 
     * @summary Get validation errors for an upload
     * @param {string} uploadId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    getValidationErrors(uploadId: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<ValidationErrorsPageDtoDto>;

    /**
     * 
     * @summary Get validation errors filtered by business error type
     * @param {string} uploadId 
     * @param {BusinessErrorTypeDto} businessErrorType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    getValidationErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<ValidationErrorsPageDtoDto>;

    /**
     * Without a body every error of the type is accepted as it is; for SAP_NUMBER_CHANGED that means the stored employee takes over the new SAP number. With a body the given resolution is chosen for every error of the type - allowed are ACCEPT_SAP_NUMBER (SAP_NUMBER_CHANGED) and SKIP_ROW (SAP_NUMBER_CHANGED, EMPLOYEE_EMAIL_CONFLICT). EMPLOYEE_EMAIL_CONFLICT always needs a resolution.
     * @summary Resolve all validation errors of specific business type
     * @param {string} uploadId 
     * @param {BusinessErrorTypeDto} businessErrorType 
     * @param {ValidationResolveByTypeRequestDto} [validationResolveByTypeRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    resolveErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, validationResolveByTypeRequestDto?: ValidationResolveByTypeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Resolve multiple validation errors
     * @param {string} uploadId 
     * @param {ResolveMultipleErrorsRequestDtoDto} [resolveMultipleErrorsRequestDtoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    resolveMultipleValidationErrors(uploadId: string, resolveMultipleErrorsRequestDtoDto?: ResolveMultipleErrorsRequestDtoDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Accepts the error as it is. An error that offers a choice of resolutions is resolved with its acceptance (SAP_NUMBER_CHANGED: the stored employee takes over the new SAP number); one without an acceptance, such as EMPLOYEE_EMAIL_CONFLICT, needs a resolution chosen through the resolution endpoint.
     * @summary Resolve a specific validation error
     * @param {string} uploadId 
     * @param {string} errorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApiInterface
     */
    resolveValidationError(uploadId: string, errorId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ValidationApi - object-oriented interface
 * @export
 * @class ValidationApi
 * @extends {BaseAPI}
 */
export class ValidationApi extends BaseAPI implements ValidationApiInterface {
    /**
     * Picks one of the resolutions the error offers in resolutionOptions and marks the error resolved. The choice is applied when the upload continues: SKIP_ROW leaves the rows out of the import, KEEP_SAP_NUMBER imports only the row with the given SAP number and leaves the other rows sharing its e-mail out, ACCEPT_SAP_NUMBER lets the stored employee take over the new SAP number.
     * @summary Choose how to resolve a validation error
     * @param {string} uploadId 
     * @param {string} errorId 
     * @param {ValidationResolutionChoiceDto} validationResolutionChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public chooseValidationErrorResolution(uploadId: string, errorId: string, validationResolutionChoiceDto: ValidationResolutionChoiceDto, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).chooseValidationErrorResolution(uploadId, errorId, validationResolutionChoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Continue upload after resolving errors
     * @param {string} uploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public continueUpload(uploadId: string, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).continueUpload(uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get validation error statistics grouped by type
     * @param {string} uploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public getValidationErrorStatistics(uploadId: string, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).getValidationErrorStatistics(uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get validation errors for an upload
     * @param {string} uploadId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public getValidationErrors(uploadId: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).getValidationErrors(uploadId, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get validation errors filtered by business error type
     * @param {string} uploadId 
     * @param {BusinessErrorTypeDto} businessErrorType 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public getValidationErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).getValidationErrorsByBusinessType(uploadId, businessErrorType, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Without a body every error of the type is accepted as it is; for SAP_NUMBER_CHANGED that means the stored employee takes over the new SAP number. With a body the given resolution is chosen for every error of the type - allowed are ACCEPT_SAP_NUMBER (SAP_NUMBER_CHANGED) and SKIP_ROW (SAP_NUMBER_CHANGED, EMPLOYEE_EMAIL_CONFLICT). EMPLOYEE_EMAIL_CONFLICT always needs a resolution.
     * @summary Resolve all validation errors of specific business type
     * @param {string} uploadId 
     * @param {BusinessErrorTypeDto} businessErrorType 
     * @param {ValidationResolveByTypeRequestDto} [validationResolveByTypeRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public resolveErrorsByBusinessType(uploadId: string, businessErrorType: BusinessErrorTypeDto, validationResolveByTypeRequestDto?: ValidationResolveByTypeRequestDto, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).resolveErrorsByBusinessType(uploadId, businessErrorType, validationResolveByTypeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve multiple validation errors
     * @param {string} uploadId 
     * @param {ResolveMultipleErrorsRequestDtoDto} [resolveMultipleErrorsRequestDtoDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public resolveMultipleValidationErrors(uploadId: string, resolveMultipleErrorsRequestDtoDto?: ResolveMultipleErrorsRequestDtoDto, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).resolveMultipleValidationErrors(uploadId, resolveMultipleErrorsRequestDtoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts the error as it is. An error that offers a choice of resolutions is resolved with its acceptance (SAP_NUMBER_CHANGED: the stored employee takes over the new SAP number); one without an acceptance, such as EMPLOYEE_EMAIL_CONFLICT, needs a resolution chosen through the resolution endpoint.
     * @summary Resolve a specific validation error
     * @param {string} uploadId 
     * @param {string} errorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidationApi
     */
    public resolveValidationError(uploadId: string, errorId: string, options?: RawAxiosRequestConfig) {
        return ValidationApiFp(this.configuration).resolveValidationError(uploadId, errorId, options).then((request) => request(this.axios, this.basePath));
    }
}

